import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import FeedbackForm from '@/views/components/feedback/FeedbackForm.vue';
import UserSettingsRepository from '@/services/repository/UserSettingsRepository';
import LoggedUserManager from '@/services/LoggedUserManager';
import AppConfig from '@/configLoader';
var userSettingsRepository;
const ONE_YEAR_MS = 31556926000;
let Feedback = class Feedback extends Vue {
    constructor() {
        super(...arguments);
        this.settings = null;
        this.lastShownTimestamp = null;
        this.isSubmitted = null;
        this.isButtonAvailable = false;
    }
    created() {
        userSettingsRepository = UserSettingsRepository.getInstance(this);
        this.loadData();
        this.$eventBus.$on('changeRateUsBtnState', (value) => {
            this.loadData();
        });
    }
    async loadData() {
        if (!this.isAdmin) {
            this.settings = await userSettingsRepository.loadUserSettings();
            this.checkButtonVisibility();
        }
    }
    checkButtonVisibility() {
        this.lastShownTimestamp = Number(this.settings.userRating.lastShownTimestamp);
        this.isSubmitted = this.settings.userRating.isSubmitted == 'true' ? true : false;
        const now = Date.now();
        if (!this.isSubmitted) {
            this.isButtonAvailable = true;
        }
        else {
            if (this.lastShownTimestamp + ONE_YEAR_MS < now) {
                this.isButtonAvailable = true;
            }
            else {
                this.isButtonAvailable = false;
            }
        }
    }
    get userRatingEnabled() {
        return AppConfig.getConfig().features.user_star_rating;
    }
    get isAdmin() {
        return LoggedUserManager.isAdmin();
    }
    rateUs() {
        this.$eventBus.$emit('openRateUsPopupModal', true);
    }
};
Feedback = __decorate([
    Component({ components: { FeedbackForm } })
], Feedback);
export default Feedback;
